import React from 'react';
import { LineChart } from 'lucide-react';
import { Button } from './ui/button';

const CRYPTO_HINTS = ['USDT', 'USD', 'BTC', 'ETH', 'BINANCE:', 'BYBIT:', 'CCC:', 'CRYPTO:'];
const STOCK_HINTS = ['NASDAQ:', 'NYSE:', 'AMEX:', 'EURONEXT:'];

/**
 * Best-effort mapping of an internal symbol to a TradingView chart URL.
 */
export function tradingViewUrl(symbol) {
  if (!symbol) return 'https://www.tradingview.com/chart/';
  let s = String(symbol).toUpperCase().replace(/\s+/g, '').replace('/', '');
  // Already prefixed (BINANCE:BTCUSDT, NASDAQ:AAPL, ...): keep as-is
  if (s.includes(':')) return `https://www.tradingview.com/chart/?symbol=${encodeURIComponent(s)}`;
  // Crypto vs stock guess
  if (CRYPTO_HINTS.some((h) => s.includes(h.replace(':', '')))) {
    return `https://www.tradingview.com/chart/?symbol=${encodeURIComponent('BINANCE:' + s)}`;
  }
  return `https://www.tradingview.com/chart/?symbol=${encodeURIComponent(s)}`;
}

/**
 * Small button/link that opens TradingView chart for the given symbol.
 * If no symbol, opens the generic TradingView chart page.
 */
export default function TradingViewLink({
  symbol,
  label = 'TradingView',
  variant = 'outline',
  size = 'sm',
  className = '',
  showIcon = true,
  'data-testid': testId = 'open-tradingview',
}) {
  const url = tradingViewUrl(symbol);
  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
      className={`border-primary/40 hover:bg-primary/10 ${className}`}
      data-testid={testId}
    >
      {showIcon && <LineChart className="w-4 h-4 mr-2" />}
      {label}
    </Button>
  );
}
